import ClientLabel from './ClientLabel';

export default ClientLabel;
